module.exports = "/assets/data/589cbc235ba998ee7fdd06db82c13725-TS4.data.json";